<template>
  <div>
        <div v-if="list[checkDesc]">
          <el-tooltip effect="dark" placement="top" v-if="list[checkDesc].length > 10 && hasToolTip">
            <div slot="content" class="content">
              <el-scrollbar style="height: 100%" class="replyContent">
                {{ list[checkDesc] }}
              </el-scrollbar>
            </div>
            <span>{{ list[checkDesc].substr(0, 10) }}......</span>
          </el-tooltip>
            <span v-else-if="list[checkDesc].length <= 10 || !hasToolTip">{{
              list[checkDesc]
              }}</span>
            <i v-if="!isCheck && list[checkDesc].includes('****')"
              class="iconfont iconfuwuzhiliang-mingwen phone"
              @click="checkMessage(list,checkUrl)"
            />
        </div>
        <span v-else>--</span>
  </div>
</template>

<script>
// import { getCheckMessage } from '@views/pool'
import { RESPONSE_CODE } from '@public/http/config'
import { copyText } from '@/common/utils/tool'

export default {

  data() {
    return {
      COM_HTTP: {},
      isCheck: false,
      list: {}
    };
  },
  props: {
    // 行数据
    value: {
      type: Object,
      default: () => ({})
    },
    // 反查参数
    checkDesc: {
      type: String,
      default: 'probleDescription'
    },
    // 反查接口名
    checkUrl: {
      type: String,
      default: 'getProbleDesc'
    },
    // 是否有提示框与截取字符串
    hasToolTip: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.list = this.value
  },
  //   computed:{
  // list(){
  //   const list = this.value || {}
  //   return list
  // }
  //   },
  watch: {
    value: {
      handler (newVal, oldVal) {
        this.isCheck = false// 重新刷新数据的话，不会执行created,要手动重置
        this.list = newVal
      },
      deep: true
    }
  },
  methods: {
    // 查看留言内容  row---传入对象，isCheck---反查标识，reqMsg---接口名
    async checkMessage(row, reqMsg) {
      try {
        const problemPieceId = row?.problemPieceId
        const { code, msg, data } = await this.COM_HTTP[reqMsg]({ id: row.id, problemPieceId })
        if (code === RESPONSE_CODE.SUCCESS) {
          row[this.checkDesc] = data[this.checkDesc]
          copyText(data[this.checkDesc])
          this.isCheck = true
          // this.$set(row,  true)
          // row[isCheckMsg] = true
          return
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 320px;
  height: 100px;
  // height:calc(100% - 1000px);
}
.replyContent {
  ::v-deep {
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
}
    .phone {
    float: right;
    // margin-left: 3px;
    cursor: pointer;
  }
</style>
